"use client";

import type { ReactNode } from "react";
import { RahuKaal } from "@/components/rahu-kaal";
import type { MuhuratResponse } from "@/lib/api/muhurat";

export default function RahuKaalClient({
  defaultCity = "New Delhi",
  initialDate,
  initialResult,
  resultOffer,
  crossLinks,
}: {
  defaultCity?: string;
  initialDate?: string;
  initialResult?: MuhuratResponse | null;
  resultOffer: ReactNode;
  crossLinks: ReactNode;
}) {
  return (
    <div className="intent-interface-timing-first min-h-[calc(100vh-130px)]">
      <RahuKaal
        defaultCity={defaultCity}
        initialDate={initialDate}
        initialResult={initialResult}
        resultOffer={resultOffer}
        crossLinks={crossLinks}
      />
    </div>
  );
}
